import React from 'react';

const TicketOffSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd">
            <path
                fillRule="nonzero"
                d="M2 2.707L2.705 2l19.092 19.092-.707.707z"
            />
            <path d="M4 5.71l1 1v-1l-1-1v1zM19 19.7l1 1v1l-1-1v-1zM15 2s0 3.5-3 3.5S9 2 9 2H4v20h5s0-3 3-3 3 3 3 3h5V2h-5zm4 19h-3c-.363-1.66-1.561-3-4-3s-3.625 1.34-4 3H5V3h3c.366 1.66 1.483 3.5 4 3.5s3.634-1.84 4-3.5h3v18zm-2-8.5h-2v-1h2v1zm-4 0h-2v-1h2v1zm-4 0H7v-1h2v1z" />
        </g>
    </svg>
);

TicketOffSvg.displayName = 'TicketOffSvg';
export default TicketOffSvg;
